module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/banner/banner.component.html
// module id = ./src/app/banner/banner.component.html
// module chunks = main